import { render, staticRenderFns } from "./TheSplashScreen.vue?vue&type=template&id=6fc3a724&"
import script from "./TheSplashScreen.vue?vue&type=script&lang=js&"
export * from "./TheSplashScreen.vue?vue&type=script&lang=js&"
import style0 from "./TheSplashScreen.vue?vue&type=style&index=0&id=6fc3a724&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports